import "core-js/modules/es.array.push.js";
import "core-js/modules/es.error.cause.js";
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-027e3eb6"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "user-manage-container"
};
const _hoisted_2 = {
  style: {
    "display": "flex",
    "align-items": "center"
  }
};
const _hoisted_3 = {
  class: "flex align-center"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  style: {
    "margin-right": "10px"
  }
}, "申请状态：", -1));
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "width": "20px"
  }
}, null, -1));
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  style: {
    "margin-right": "10px"
  }
}, "审核类型：", -1));
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "width": "20px"
  }
}, null, -1));
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  style: {
    "margin-right": "10px"
  }
}, "门诊/租户名称：", -1));
const _hoisted_9 = {
  style: {
    "margin-left": "20px"
  }
};
import { delUserApproval } from '@/api/user';
import { findDongleApprovalPage, findAuthPlatformApprovalPage, updateDongleApproval, updateApplicationApproval, rejectDongleApproval, rejectAuthPlatformApproval, getApprovalProcess } from '@/api/approval';
import { ElMessage, ElMessageBox, ElInput } from 'element-plus';
import { ref, onMounted, h, watch } from 'vue';
import Table from './components/table.vue';
import { TYPE_OPTIONS, APPROVAL_STATUS_OPTIONS, APPLY_APPROVAL_TYPE, hisTableSchema, platTableSchema } from './config';
import { Search, Refresh } from '@element-plus/icons-vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
export default {
  __name: 'index',
  setup(__props) {
    const router = useRouter();
    const approvalType = ref(3);
    const approvalStatus = ref('');
    const applyApprovalType = ref('');
    const keyword = ref('');
    const schema = ref(hisTableSchema);

    // 数据相关
    const tableData = ref([]);
    const total = ref(0);
    const page = ref(1);
    const size = ref(12);
    const loading = ref(false);
    const store = useStore();
    // 工作台跳转至本页面
    watch(() => router.currentRoute.value.path, toPath => {
      if (router.currentRoute.value.query.tab) {
        approvalType.value = +router.currentRoute.value.query.tab;
      } else {
        approvalType.value = 3;
      }
      if (router.currentRoute.value.query.isWait) {
        approvalStatus.value = 1;
      } else {
        approvalStatus.value = '';
      }
    }, {
      immediate: true,
      deep: true
    });
    const _findDongleApprovalPage = async () => {
      var _store$getters$userIn;
      loading.value = true;
      const result = await findDongleApprovalPage({
        currentPage: page.value,
        pageSize: size.value,
        approvalType: 1,
        approvalStatus: approvalStatus.value,
        auditorId: (_store$getters$userIn = store.getters.userInfo) === null || _store$getters$userIn === void 0 || (_store$getters$userIn = _store$getters$userIn.sysUser) === null || _store$getters$userIn === void 0 ? void 0 : _store$getters$userIn.id,
        applyApprovalType: applyApprovalType.value,
        keyword: keyword.value
      });
      tableData.value = result.records;
      total.value = result.total;
      loading.value = false;
    };

    // 获取数据的方法
    const _findAuthPlatformApprovalPage = async () => {
      var _store$getters$userIn2;
      loading.value = true;
      const result = await findAuthPlatformApprovalPage({
        currentPage: page.value,
        pageSize: size.value,
        approvalType: approvalType.value === 1 ? 2 : 3,
        type: approvalType.value === 3 ? '' : approvalType.value,
        approvalStatus: approvalStatus.value,
        auditorId: (_store$getters$userIn2 = store.getters.userInfo) === null || _store$getters$userIn2 === void 0 || (_store$getters$userIn2 = _store$getters$userIn2.sysUser) === null || _store$getters$userIn2 === void 0 ? void 0 : _store$getters$userIn2.id,
        applyApprovalType: applyApprovalType.value,
        keyword: keyword.value
      });
      tableData.value = result.records;
      total.value = result.total;
      loading.value = false;
    };
    const loadApprovalData = () => {
      // eslint-disable-next-line
      if (approvalType.value == 3) {
        schema.value = hisTableSchema;
        _findDongleApprovalPage();
        // eslint-disable-next-line
      } else {
        schema.value = platTableSchema;
        _findAuthPlatformApprovalPage();
      }
    };
    onMounted(() => {
      loadApprovalData();
    });
    const handleTabChange = () => {
      // console.log(approvalType.value, '=========')
      approvalStatus.value = '';
      applyApprovalType.value = '';
      keyword.value = '';
      page.value = 1;
      loadApprovalData();
    };
    const handleRefresh = async () => {
      approvalStatus.value = '';
      applyApprovalType.value = '';
      keyword.value = '';
      page.value = 1;
      loadApprovalData();
    };
    const handleCurrentChange = val => {
      page.value = val;
      loadApprovalData();
    };
    const handleToApproval = row => {
      router.push(`/application/approval/${row.approvalItemId}`);
    };
    const judgeApproval = async row => {
      const res = await getApprovalProcess({
        approvalItemId: row.approvalItemId
      });
      const index = res[0].approvalList.findIndex(item => {
        var _store$getters$userIn3;
        return item.auditorId === ((_store$getters$userIn3 = store.getters.userInfo) === null || _store$getters$userIn3 === void 0 || (_store$getters$userIn3 = _store$getters$userIn3.sysUser) === null || _store$getters$userIn3 === void 0 ? void 0 : _store$getters$userIn3.id);
      });
      if (index === 0) return true;
      if (res[0].approvalList[index - 1].approvalStatus === 2) {
        return true;
      } else {
        ElMessage.error('上一级审批未完成');
        return false;
      }
    };
    const handleConfirm = async row => {
      const flag = await judgeApproval(row);
      if (!flag) return;
      ElMessageBox.confirm('是否确认审核该条记录', '温馨提示!', {}).then(async () => {
        if (approvalType.value === 3) {
          // his
          await updateDongleApproval({
            id: row.id,
            approvalItemId: row.approvalItemId,
            approvalStatus: 2,
            approvalVersion: row.approvalVersion
          });
        } else {
          // web
          await updateApplicationApproval({
            id: row.id,
            approvalItemId: row.approvalItemId,
            approvalStatus: 2,
            approvalVersion: row.approvalVersion
          });
        }
        await loadApprovalData();
        ElMessage.success('审核成功');
      });
    };
    const handleReject = async row => {
      const flag = await judgeApproval(row);
      if (!flag) return;
      const value = ref('');
      ElMessageBox({
        title: '温馨提示!',
        showCancelButton: true,
        message: () => h(ElInput, {
          modelValue: value.value,
          placeholder: '请输入拒绝原因',
          type: 'textarea',
          autosize: {
            minRows: 5
          },
          'onUpdate:modelValue': val => {
            value.value = val;
          }
        })
      }).then(async () => {
        if (approvalType.value === 3) {
          // his
          await rejectDongleApproval({
            id: row.id,
            approvalItemId: row.approvalItemId,
            approvalStatus: 3,
            remark: value.value,
            approvalVersion: row.approvalVersion
          });
        } else {
          // web
          await rejectAuthPlatformApproval({
            id: row.id,
            approvalItemId: row.approvalItemId,
            approvalStatus: 3,
            remark: value.value,
            approvalVersion: row.approvalVersion
          });
        }
        await loadApprovalData();
        ElMessage.success('拒绝成功');
      });
    };
    const applicationSelections = ref([]);
    const handleSelectionChange = val => {
      applicationSelections.value = val;
    };
    const handleBatchPass = async () => {
      if (!applicationSelections.value.length) {
        return ElMessage.warning('请选择需要审核的应用');
      }
      ElMessageBox.confirm('是否确认审核该条记录', '温馨提示!', {}).then(async () => {
        const selections = [];
        applicationSelections.value.forEach(item => {
          const promiseItem = new Promise((resolve, reject) => {
            judgeApproval(item).then(flag => {
              if (!flag) return resolve(new Error(''));
              if (approvalType.value === 3) {
                updateDongleApproval({
                  id: item.id,
                  approvalItemId: item.approvalItemId,
                  approvalStatus: 2,
                  approvalVersion: item.approvalVersion
                }).then(res => {
                  resolve(res);
                }).catch(err => {
                  reject(err);
                });
              } else {
                updateApplicationApproval({
                  id: item.id,
                  approvalItemId: item.approvalItemId,
                  approvalStatus: 2,
                  approvalVersion: item.approvalVersion
                }).then(res => {
                  resolve(res);
                }).catch(err => {
                  reject(err);
                });
              }
            }).catch(error => {
              reject(new Error(error));
            });
          });
          selections.push(promiseItem);
        });
        await Promise.all(selections);
        await loadApprovalData();
        ElMessage.success('拒绝成功');
      });
    };
    const handleBatchReject = () => {
      if (!applicationSelections.value.length) {
        return ElMessage.warning('请选择需要审核的应用');
      }
      const value = ref('');
      ElMessageBox({
        title: '温馨提示!',
        showCancelButton: true,
        message: () => h(ElInput, {
          modelValue: value.value,
          placeholder: '请输入拒绝原因',
          type: 'textarea',
          autosize: {
            minRows: 5
          },
          'onUpdate:modelValue': val => {
            value.value = val;
          }
        })
      }).then(async () => {
        const selections = [];
        applicationSelections.value.forEach(item => {
          const promiseItem = new Promise((resolve, reject) => {
            judgeApproval(item).then(flag => {
              if (!flag) return resolve(new Error(''));
              if (approvalType.value === 3) {
                rejectDongleApproval({
                  id: item.id,
                  approvalItemId: item.approvalItemId,
                  approvalStatus: 3,
                  remark: value.value,
                  approvalVersion: item.approvalVersion
                }).then(res => {
                  resolve(res);
                }).catch(err => {
                  reject(err);
                });
              } else {
                updateApplicationApproval({
                  id: item.id,
                  approvalItemId: item.approvalItemId,
                  approvalStatus: 2,
                  approvalVersion: item.approvalVersion
                }).then(res => {
                  resolve(res);
                }).catch(err => {
                  reject(err);
                });
              }
            }).catch(error => {
              reject(new Error(error));
            });
          });
          selections.push(promiseItem);
        });
        await Promise.all(selections);
        await loadApprovalData();
        ElMessage.success('审核成功');
      });
    };
    const delUserHandler = row => {
      ElMessageBox.confirm('确认要删除吗', {
        type: 'warning'
      }).then(async () => {
        try {
          await delUserApproval(row.id);
          ElMessage.success('删除成功');
          // 重新渲染数据
          loadApprovalData();
        } catch (error) {
          ElMessage({
            message: error,
            type: 'error'
          });
        }
      });
    };
    return (_ctx, _cache) => {
      const _component_el_tab_pane = _resolveComponent("el-tab-pane");
      const _component_el_tabs = _resolveComponent("el-tabs");
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_card = _resolveComponent("el-card");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_card, {
        shadow: "never",
        style: {
          "border": "none"
        }
      }, {
        default: _withCtx(() => [_createVNode(_component_el_tabs, {
          modelValue: approvalType.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => approvalType.value = $event),
          type: "card",
          class: "demo-tabs",
          onTabChange: handleTabChange
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(TYPE_OPTIONS), item => {
            return _openBlock(), _createBlock(_component_el_tab_pane, {
              key: item.value,
              label: item.label,
              name: item.value
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(item.content), 1)]),
              _: 2
            }, 1032, ["label", "name"]);
          }), 128))]),
          _: 1
        }, 8, ["modelValue"]), _createVNode(_component_el_card, {
          class: "header",
          shadow: "never",
          style: {
            "border": "none"
          }
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_hoisted_4, _createVNode(_component_el_select, {
            modelValue: approvalStatus.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => approvalStatus.value = $event),
            style: {
              "width": "200px"
            },
            placeholder: "选择审批状态"
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(APPROVAL_STATUS_OPTIONS), item => {
              return _openBlock(), _createBlock(_component_el_option, {
                key: item.value,
                label: item.label,
                value: item.value
              }, null, 8, ["label", "value"]);
            }), 128))]),
            _: 1
          }, 8, ["modelValue"]), _hoisted_5, _hoisted_6, _createVNode(_component_el_select, {
            modelValue: applyApprovalType.value,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => applyApprovalType.value = $event),
            style: {
              "width": "200px"
            },
            placeholder: "选择审批状态"
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(APPLY_APPROVAL_TYPE), item => {
              return _openBlock(), _createBlock(_component_el_option, {
                key: item.value,
                label: item.label,
                value: item.value
              }, null, 8, ["label", "value"]);
            }), 128))]),
            _: 1
          }, 8, ["modelValue"]), _hoisted_7, _hoisted_8, _createVNode(_unref(ElInput), {
            modelValue: keyword.value,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => keyword.value = $event),
            style: {
              "width": "200px"
            },
            placeholder: "请输入门诊/租户名称"
          }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_9, [_createVNode(_component_el_button, {
            type: "primary",
            icon: _unref(Search),
            onClick: loadApprovalData
          }, {
            default: _withCtx(() => [_createTextVNode(" 查询 ")]),
            _: 1
          }, 8, ["icon"]), _createVNode(_component_el_button, {
            icon: _unref(Refresh),
            onClick: handleRefresh
          }, {
            default: _withCtx(() => [_createTextVNode(" 重置 ")]),
            _: 1
          }, 8, ["icon"]), _createVNode(_component_el_button, {
            type: "success",
            onClick: handleBatchPass
          }, {
            default: _withCtx(() => [_createTextVNode(" 批量通过 ")]),
            _: 1
          }), _createVNode(_component_el_button, {
            type: "danger",
            onClick: handleBatchReject
          }, {
            default: _withCtx(() => [_createTextVNode(" 批量拒绝 ")]),
            _: 1
          })])])]),
          _: 1
        }), _createVNode(_component_el_card, {
          shadow: "never",
          style: {
            "border": "none"
          }
        }, {
          default: _withCtx(() => [_createVNode(Table, {
            data: tableData.value,
            approvalType: approvalType.value === 3 ? 1 : 2,
            page: page.value,
            size: size.value,
            total: total.value,
            schema: schema.value,
            onDelUserHandler: delUserHandler,
            onHandleCurrentChange: handleCurrentChange,
            onApproval: handleToApproval,
            onConfirm: handleConfirm,
            onReject: handleReject,
            onSelection: handleSelectionChange,
            loading: loading.value
          }, null, 8, ["data", "approvalType", "page", "size", "total", "schema", "loading"])]),
          _: 1
        })]),
        _: 1
      })]);
    };
  }
};